<template>
  <div class="flex-container">
    <div class="flex-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/sys/merchant/merchantList' }">商户管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/sys/merchant/merchantDetail/' + channelId + '/' + merchantId }">{{ merchantName }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/sys/merchant/storeList/' + merchantId }">门店列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ store.storeName || '门店详情' }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="store-header" v-if="store.storeName">
        <h2 class="store-title">
          {{ store.storeName }}
          <span class="store-code">（{{ store.storeCode }}）</span>
          <el-tag :type="store.status === '1' ? 'success' : 'danger'" size="small" style="margin-left:10px;">
            {{ store.status === '1' ? '正常' : '停用' }}
          </el-tag>
          <el-tag v-if="latestAuditStatus" :type="latestAuditStatusColor" size="small" style="margin-left:6px;">
            {{ latestAuditStatusLabel }}
          </el-tag>
        </h2>
      </div>
    </div>
    <div class="flex-item main-content">
      <el-tabs v-model="activeTab" class="detail-tabs">
        <el-tab-pane label="基本信息" name="basic">
          <el-card class="section-card" shadow="never">
            <div slot="header" class="section-header"><span>门店信息</span></div>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="门店名称">{{ store.storeName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="门店编码">{{ store.storeCode || '-' }}</el-descriptions-item>
              <el-descriptions-item label="门店地址" :span="2">{{ store.address || '-' }}</el-descriptions-item>
              <el-descriptions-item label="联系人">{{ store.contact || '-' }}</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{ store.phone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="面积(㎡)">{{ store.area || '-' }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ store.createTime || '-' }}</el-descriptions-item>
              <el-descriptions-item label="所属商户" :span="2">{{ merchantName || '-' }}</el-descriptions-item>
            </el-descriptions>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="申请记录" name="audit">
          <div class="audit-timeline-scroll">
            <el-timeline v-if="auditRecords.length > 0" reverse>
              <el-timeline-item v-for="(item, index) in auditRecords" :key="index" :timestamp="item.time" placement="top" :color="getTimelineColor(item.type)">
                <el-card shadow="never" class="audit-card">
                  <div class="audit-card-header">
                    <span class="audit-type-tag" :class="'audit-type-' + getAuditTypeClass(item.type)">
                      <template v-if="item.type === '提交审核'"><i class="el-icon-upload"></i> {{ item.type }} ({{ item.version }})</template>
                      <template v-else-if="item.type.includes('通过')"><i class="el-icon-circle-check"></i> {{ item.type }}</template>
                      <template v-else><i class="el-icon-circle-close"></i> {{ item.type }}</template>
                    </span>
                    <span class="audit-version-badge">{{ item.version }}</span>
                  </div>
                  <div class="audit-card-body">
                    <div class="audit-info-row" v-if="item.auditor"><span class="audit-info-label">审核人：</span><span class="audit-info-value">{{ item.auditor }}</span></div>
                    <div class="audit-info-row" v-if="item.operator"><span class="audit-info-label">操作人：</span><span class="audit-info-value">{{ item.operator }}</span></div>
                    <div class="audit-info-row"><span class="audit-info-label">时间：</span><span class="audit-info-value">{{ item.time }}</span></div>
                    <div class="audit-info-row">
                      <span class="audit-info-label">审核依据：</span>
                      <span class="audit-info-value">{{ item.version }} 版本资料</span>
                      <el-button type="text" size="mini" @click="downloadFile(item.fileName)" style="margin-left:8px;"><i class="el-icon-download"></i> {{ item.fileName }}</el-button>
                    </div>
                    <div class="audit-opinion" v-if="item.opinion"><span class="audit-info-label">意见：</span><span style="color:#606266;">{{ item.opinion }}</span></div>
                  </div>
                </el-card>
              </el-timeline-item>
            </el-timeline>
            <el-empty v-else description="暂无申请记录" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="form-footer-fixed">
      <el-button size="medium" @click="goBack"><i class="el-icon-back"></i> 返回门店列表</el-button>
      <span class="footer-hint">门店：{{ store.storeName }}（{{ store.storeCode }}）</span>
    </div>
  </div>
</template>

<script>
import { mockStores, storeAuditRecords } from "../workflow/mockData";
import { mockMerchants } from "../workflow/mockData";

export default {
  name: "storeDetail",
  data() {
    return {
      channelId: '',
      merchantId: '',
      storeId: '',
      merchantName: '',
      store: {},
      activeTab: 'basic',
      auditRecords: [],
    };
  },
  computed: {
    latestAuditStatus() { return this.auditRecords.length > 0 ? this.auditRecords[0] : null; },
    latestAuditStatusLabel() { return this.latestAuditStatus ? this.latestAuditStatus.type + '(' + this.latestAuditStatus.version + ')' : ''; },
    latestAuditStatusColor() {
      if (!this.latestAuditStatus) return '';
      const t = this.latestAuditStatus.type;
      if (t.includes('通过')) return 'success';
      if (t.includes('驳回') || t.includes('不通过')) return 'danger';
      return 'warning';
    }
  },
  created() {
    this.channelId = this.$route.params.channelId || '';
    this.merchantId = this.$route.params.merchantId || '';
    this.storeId = this.$route.params.storeId || '';
    this.loadData();
  },
  methods: {
    loadData() {
      const merchant = mockMerchants.find(m => m.merchantId === this.merchantId);
      this.merchantName = merchant ? merchant.merchantName : '未知商户';
      const found = mockStores.find(s => s.storeId === this.storeId);
      if (found) {
        this.store = { ...found };
        this.auditRecords = storeAuditRecords[this.storeId] || [];
      }
    },
    getTimelineColor(type) {
      if (type.includes('通过')) return '#67C23A';
      if (type.includes('驳回') || type.includes('不通过')) return '#F56C6C';
      return '#409EFF';
    },
    getAuditTypeClass(type) {
      if (type.includes('通过')) return 'pass';
      if (type.includes('驳回') || type.includes('不通过')) return 'reject';
      return 'submit';
    },
    goBack() { this.$router.push('/sys/merchant/storeList/' + this.merchantId); },
    downloadFile(fileName) { this.$message.success('下载文件：' + fileName); },
  }
};
</script>

<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; text-align: left; }
.flex-header { flex-shrink: 0; background: #fff; padding-bottom: 8px; }
.flex-item:nth-child(2) { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.main-content { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.detail-tabs { margin-top: 8px; display: flex; flex-direction: column; height: 100%; }
.detail-tabs >>> .el-tabs__header { background: #fff; padding: 0 20px; border-radius: 6px 6px 0 0; margin-bottom: 0; flex-shrink: 0; }
.detail-tabs >>> .el-tabs__content { flex: 1; min-height: 0; overflow-y: auto; overflow-x: hidden; padding: 0; }
.detail-tabs >>> .el-tabs__content .el-tab-pane { height: 100%; padding: 16px 0; }
.store-header { padding: 14px 20px; background: #fff; border-radius: 8px; margin-top: 8px; border: 1px solid #ebeef5; }
.store-title { font-size: 18px; font-weight: 600; color: #303133; margin: 0; }
.store-code { font-size: 14px; font-weight: 400; color: #909399; }
.section-card { border-radius: 6px; }
.section-card >>> .el-card__header { padding: 12px 20px; background: #f8f9fc; border-bottom: 1px solid #ebeef5; }
.section-header { font-size: 15px; font-weight: 600; color: #303133; display: flex; align-items: center; }
.section-header::before { content: ''; display: inline-block; width: 3px; height: 16px; background: #409EFF; border-radius: 2px; margin-right: 8px; }
.audit-timeline-scroll { height: 100%; overflow-y: auto; overflow-x: hidden; padding-right: 6px; }
.audit-timeline-scroll::-webkit-scrollbar { width: 8px; }
.audit-timeline-scroll::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.audit-timeline-scroll::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 4px; }
.audit-timeline-scroll::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }
.audit-card { border-left: 3px solid #409EFF; padding: 4px 8px; }
.audit-card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.audit-type-tag { display: inline-flex; align-items: center; gap: 4px; font-size: 14px; font-weight: 600; padding: 2px 10px; border-radius: 4px; }
.audit-type-pass { color: #67C23A; background: #f0f9eb; }
.audit-type-reject { color: #F56C6C; background: #fef0f0; }
.audit-type-submit { color: #409EFF; background: #ecf5ff; }
.audit-version-badge { font-size: 11px; padding: 1px 8px; border-radius: 10px; background: #e6e6e6; color: #666; }
.audit-card-body { font-size: 13px; line-height: 1.8; }
.audit-info-row { display: flex; align-items: center; flex-wrap: wrap; }
.audit-info-label { color: #909399; flex-shrink: 0; width: 72px; }
.audit-info-value { color: #303133; }
.audit-opinion { margin-top: 6px; padding: 8px 12px; background: #fafafa; border-radius: 4px; border-left: 2px solid #e6a23c; }
.form-footer-fixed { text-align: center; padding: 16px 0; border-top: 1px solid #ebeef5; background: #fff; flex-shrink: 0; position: relative; z-index: 10; }
.form-footer-fixed .el-button { min-width: 140px; }
.footer-hint { margin-left: 20px; font-size: 13px; color: #909399; }
</style>
